import React from 'react';
import { Result, Button } from 'antd';

export default function ErrorPage(): JSX.Element {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Result
        status="500"
        subTitle="Sorry, something went wrong."
        extra={
          <Button size={'small'} type="primary" href="/">
            Back Home
          </Button>
        }
      />
    </div>
  );
}
